import { Injectable, signal } from '@angular/core';

interface AuditLogHeaderHandlers {
  reset: () => void;
  export: () => void;
}

@Injectable({ providedIn: 'root' })
export class AuditLogHeaderService {
  private readonly activeState = signal(false);
  private connection: symbol | null = null;
  private handlers: AuditLogHeaderHandlers | null = null;

  readonly active = this.activeState.asReadonly();

  connect(handlers: AuditLogHeaderHandlers): symbol {
    const connection = Symbol('audit-log-header');
    this.connection = connection;
    this.handlers = handlers;
    this.activeState.set(true);
    return connection;
  }

  disconnect(connection: symbol): void {
    if (connection !== this.connection) return;
    this.connection = null;
    this.handlers = null;
    this.activeState.set(false);
  }

  reset(): void {
    this.handlers?.reset();
  }

  export(): void {
    this.handlers?.export();
  }
}
